import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.jpg";
import noteContext from "../context/notes/noteContext";

const Login = () => {
  const a = useContext(noteContext);
  const navigate = useNavigate();

  const [mode, setMode] = useState("login");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [resetEmail, setResetEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState("danger");

  useEffect(() => {
    return () => {
      document.body.style.paddingTop = "auto";
    };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("islogin");

    if (token) {
      const logintype = localStorage.getItem("logintype");

      navigate(
        logintype === "INSTRUCTOR"
          ? "/adminhome"
          : "/clienthome",
      );
    }
  }, []);

  if (!a || !a.data) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  const showError = (msg) => {
    setToastType("danger");
    setToastMsg(msg);
    setShowToast(true);
  };

  /* ---------- LOGIN ---------- */
  const handleLogin = async () => {
    setLoading(true);

    if (!email.trim()) {
      alert("Please enter email");
      setLoading(false);
      return;
    }

    if (!password.trim()) {
      alert("Please enter password");
      setLoading(false);
      return;
    }

    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LOGIN_API}`;

      const res = await fetch(path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          EMAIL: email,
          PASSWORD: password,
        }),
      });

      const data = await res.json();

      if (data.res === "success") {
        localStorage.setItem(
          "user",
          JSON.stringify(data.data),
        );

        localStorage.setItem("islogin", true);

        localStorage.setItem(
          "logintype",
          data.data.TYPE,
        );

        localStorage.setItem(
          "language",
          data.data.LANGUAGE_ID,
        );

        setToastType("success");
        setToastMsg("Login Success");
        setShowToast(true);

        setTimeout(() => {
          navigate(
            data.data.TYPE === "INSTRUCTOR"
              ? "/adminhome"
              : "/clienthome",
          );
        }, 800);
      } else {
        showError("Invalid Credentials");
      }
    } catch {
      showError("Server Error");
    }

    setLoading(false);
  };

  /* ---------- SEND OTP ---------- */
  const handleSendOTP = async () => {
    setLoading(true);

    if (!resetEmail.trim()) {
      alert("Enter Registered Email to send otp...");
      setLoading(false);
      return false;
    }

    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_RESET_PASSWORD}`;

      const res = await fetch(path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          EMAIL: resetEmail,
        }),
      });

      const data = await res.json();

      if (data.res === "Success") {
        setToastType("success");
        setToastMsg(data.msg);
        setShowToast(true);

        setMode("otp");
      } else {
        showError("Email Not Found");
      }
    } catch {
      showError("Server Error");
    }

    setLoading(false);
  };

  /* ---------- VERIFY OTP ---------- */
  const handleVerifyOTP = async () => {
    setLoading(true);

    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_RESET_PASSWORD_WITH_OTP}`;

      const res = await fetch(path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          EMAIL: resetEmail,
          OTP: otp,
          "New Password": newPassword,
        }),
      });

      const data = await res.json();

      if (data.res === "success") {
        setToastType("success");
        setToastMsg("Password Reset Success");
        setShowToast(true);

        setMode("login");
      } else {
        showError("Invalid OTP");
      }
    } catch {
      showError("Server Error");
    }

    setLoading(false);
  };

  return (
    <>
      {/* BACKGROUND */}
      <div
  className="d-flex justify-content-center align-items-center"
  style={{
    minHeight: "100vh",
    width: "100%",
    background:
      "linear-gradient(135deg,#0d6efd,#6610f2)",
  }}
>
        {/* LOGIN CARD */}
        <div
          className="bg-white shadow-lg p-4 rounded-4"
          style={{
            width: "420px",
            animation: "fadeIn 0.4s ease",
          }}
        >
          {/* LOGO */}
          <div className="text-center mb-3">
            <img
              src={logo}
              alt="logo"
              width="80"
              className="mb-2"
            />

            <h4 className="fw-bold">EASY ITI</h4>
          </div>

          {/* ---------- LOGIN ---------- */}
          {mode === "login" && (
            <>
              <input
                className="form-control mb-2"
                placeholder="Email"
                value={email}
                onChange={(e) =>
                  setEmail(e.target.value)
                }
              />

              <input
                type="password"
                className="form-control mb-2"
                placeholder="Password"
                value={password}
                onChange={(e) =>
                  setPassword(e.target.value)
                }
              />

              <div className="text-end mb-2">
                <span
                  className="text-primary"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={() => setMode("forgot")}
                >
                  Forgot Password?
                </span>
              </div>

              {/* LOGIN BUTTON */}
              <button
                className="btn btn-primary w-100"
                disabled={loading}
                onClick={handleLogin}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Please Wait...
                  </>
                ) : (
                  "Login"
                )}
              </button>

              {/* ABOUT + PRIVACY */}
              <div className="text-center mt-3">
                <span
                  className="text-primary me-3"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                  onClick={() =>
                    navigate("/aboutUs")
                  }
                >
                  About Us
                </span>

                <span
                  className="text-primary"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                  onClick={() =>
                    navigate("/privacypolicy")
                  }
                >
                  Privacy Policy
                </span>
              </div>
            </>
          )}

          {/* ---------- FORGOT ---------- */}
          {mode === "forgot" && (
            <>
              <input
                className="form-control mb-3"
                placeholder="Enter Email"
                value={resetEmail}
                onChange={(e) =>
                  setResetEmail(e.target.value)
                }
              />

              <button
                className="btn btn-primary w-100 mb-2"
                disabled={loading}
                onClick={handleSendOTP}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Sending OTP...
                  </>
                ) : (
                  "Send OTP"
                )}
              </button>

              <button
                className="btn btn-outline-success w-100"
                onClick={() => setMode("otp")}
              >
                I Already Have OTP
              </button>

              <div className="text-center mt-3">
                <span
                  className="text-primary"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={() => setMode("login")}
                >
                  Back to Login
                </span>
              </div>
            </>
          )}

          {/* ---------- OTP ---------- */}
          {mode === "otp" && (
            <>
              <input
                className="form-control mb-2"
                placeholder="Enter Email"
                value={resetEmail}
                onChange={(e) =>
                  setResetEmail(e.target.value)
                }
              />

              <input
                className="form-control mb-2"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) =>
                  setOtp(e.target.value)
                }
              />

              <input
                type="password"
                className="form-control mb-3"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) =>
                  setNewPassword(e.target.value)
                }
              />

              <button
                className="btn btn-success w-100"
                disabled={loading}
                onClick={handleVerifyOTP}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Verifying...
                  </>
                ) : (
                  "Reset Password"
                )}
              </button>
            </>
          )}
        </div>
      </div>

      {/* ---------- TOAST ---------- */}
      {showToast && (
        <div className="toast show position-fixed top-50 start-50 translate-middle">
          <div
            className={`toast-header bg-${toastType} text-white`}
          >
            <strong className="me-auto">
              Easy ITI
            </strong>

            <button
              className="btn-close btn-close-white"
              onClick={() =>
                setShowToast(false)
              }
            ></button>
          </div>

          <div className="toast-body">
            {toastMsg}
          </div>
        </div>
      )}
    </>
  );
};

export default Login;